import React, {Component} from 'react';
import { getFormatedCurrency, getFormatedNumber, getNeighborhoodItemText, 
    getPropertyTypeName, /* getOptionTextFromValue, getEntryDays,  */
    toProperCase, getNumberOfDaysWeeks, GetSectionCustomizationOptions } from 'components/util';

const SearchPageCustomizationOptions = GetSectionCustomizationOptions("SearchPageOptions");

class SearchTags extends Component{

    getTag(key, val, id, disabled){
        var tag = "";        
        switch (key.toLowerCase()){
            case "location": {
                //tag = this.getTagElement(key, val, "Location", id, disabled);
                tag = this.getTagElement(key, val, "", id, disabled);
                break;
            }
            case "mlsnumber": {
                tag = this.getTagElement(key, val, "MLS#", id, disabled);
                break;
            }
            case "beds": {
                tag = this.getTagElement(key, val.replace("g","+").replace("e",""), "Beds", id, disabled);
                break;
            }
            case "baths": {
                tag = this.getTagElement(key, val.replace("g","+").replace("e",""), "Bath", id, disabled);
                break;
            }
            case "garages": {
                tag = this.getTagElement(key, val.replace("g","+"), "Garage", id, disabled);
                break;
            }
            case "livingareamin": {
                tag = this.getTagElement(key, getFormatedNumber(val), "Sq. Ft. min", id, disabled);
                break;
            }
            case "livingareamax": {
                tag = this.getTagElement(key, getFormatedNumber(val), "Sq. Ft. max", id, disabled);
                break;
            }
            case "acresmin": {
                tag = this.getTagElement(key, val, "Acres min", id, disabled);
                break;
            }
            case "acresmax": {
                tag = this.getTagElement(key, val, "Acres max", id, disabled);
                break;
            }
            case "yearbuiltmin": {
                tag = this.getTagElement(key, val, "Year min", id, disabled);
                break;
            }
            case "yearbuiltmax": {
                tag = this.getTagElement(key, val, "Year max", id, disabled);
                break;
            }
            case "tlcmin": {
                tag = this.getTagElement(key, getFormatedCurrency(val), "TLC min", id, disabled);
                break;
            }
            case "tlcmax": {
                tag = this.getTagElement(key, getFormatedCurrency(val), "TLC max", id, disabled);
                break;
            }
            case "listingpricemin": {
                tag = this.getTagElement(key, getFormatedCurrency(val), "Min price", id, disabled);
                break;
            }
            case "listingpricemax": {
                tag = this.getTagElement(key, getFormatedCurrency(val), "Max price", id, disabled);
                break;
            }
            /*case "tlcminmax": {
                tag = <div key={id} onClick={() => this.props.onRemoveSearchTag("tlcminmax")} className="tag">
                        <i className="icon icon-close closeicon-breadcrum"></i>
                        {val} <span className="tag-label">TLC</span></div>
                break;
            }*/
            case "openhouseonly": {
                tag = this.getTagElement(key, "Open houses", "", id, disabled);
                break;
            }
            case "propertytype": {
                /* if(val.toLowerCase() === "sf"){
                    tag = this.getTagElement(key, "Single family", "", id, true);
                }
                else if(val.toLowerCase() === "mf"){
                    tag = this.getTagElement(key, "Multi family", "", id, true);
                }
                else if(val.toLowerCase() === "rnt"){
                    tag = this.getTagElement(key, "Rentals", "", id, true);
                } */
                //tag = this.getTagElement(key, getPropertyTypeName(val), "", id, true);
                var strVal = getPropertyTypeName(val);
                tag = this.getTagElement(key, strVal, "", id, (strVal === "Single Family Home") ? disabled : disabled);
                break;
            }
            case "commuteaddress": {
                tag = this.getTagElement(key, val, "Commute location", id, disabled);
                break;
            }
            case "polygon": {
                if(val && val.length > 0){
                    tag = this.getTagElement(key, '', "Draw 1", id, disabled);
                }                
                break;
            }
            case "hoafeemax": {
                tag = this.getTagElement(key, val, "HOA fee max", id, disabled);
                break;
            }
            case "haswaterfront": {
                tag = this.getTagElement(key, val && val === "true" ? "Waterfront" : "No waterfront", "", id, disabled);
                break;
            }
            case "haswaterview": {
                tag = this.getTagElement(key, val && val === "true" ? "WaterView" : "No waterView", "", id, disabled);
                break;
            }
            case "hasbasement": {
                tag = this.getTagElement(key, val && val === "true" ? "Basement" : "No basement", "", id, disabled);
                break;
            }
            case "haspool": {
                tag = this.getTagElement(key, val && val === "true" ? "Pool" : "No pool", "", id, disabled);
                break;
            }
            case "hasfireplace": {
                tag = this.getTagElement(key, val && val === "true" ? "Fireplace" : "No Fireplace", "", id, disabled);
                break;
            }
            case "isshortsale": {
                tag = this.getTagElement(key, val && val === "true" ? "Short sale" : "Not short sale", "", id, disabled);
                break;
            }
            case "status": {
                tag = this.getTagElement(key, val.split(',').join(', '), "Status", id, disabled);
                break;
            }
            case "waterfeatures": {
                tag = this.getTagElement(key, val, "Water Front Type", id, disabled);
                break;
            }
            case "isbankowned": {
                tag = this.getTagElement(key, val && val === "true" ? "Banked Owned" : "Not Bank Owned", "", id, disabled);
                break;
            }
            case "haswateraccess": {
                tag = this.getTagElement(key, val && val === "true" ? "Water Access" : "No Water Access", "", id, disabled);
                break;
            }
            case "hasgolfcourse": {
                tag = this.getTagElement(key, val && val === "true" ? "Golf Course" : "No Golf Course", "", id, disabled);
                break;
            }
            case "hasgreenfeatures": {
                tag = this.getTagElement(key, val && val === "true" ? "Green Features" : "No Green Features", "", id, disabled);
                break;
            }
            case "dpr": {
                tag = this.getTagElement(key, "Downpayment Assistance", "", id, disabled);
                break;
            }
            case "hasgym": {
                tag = this.getTagElement(key, "Gym", "", id, disabled);
                break;
            }
            case "hasairconditioning": {
                tag = this.getTagElement(key, "Air Conditioning", "", id, disabled);
                break;
            }
            case "hasdoorman": {
                tag = this.getTagElement(key, "Doorman", "", id, disabled);
                break;
            }
            case "hasdishwasher": {
                tag = this.getTagElement(key, "Dishwasher", "", id, disabled);
                break;
            }
            case "hasbalcony": {
                tag = this.getTagElement(key, "Balcony", "", id, disabled);
                break;
            }
            case "hasroofaccess": {
                tag = this.getTagElement(key, "Roof Access", "", id, disabled);
                break;
            }
            case "haskeylessentry": {
                tag = this.getTagElement(key, "Keyless Entry", "", id, disabled);
                break;
            }
            case "keywords": {
                tag = this.getTagElement(key, val.split(',').join(', '), "", id, disabled);
                break;
            }
            case "schooldistrictname": {
                tag = this.getTagElement(key, val, "School District", id, disabled);
                break;
            }
            case "neighborhood": {
                //tag = this.getTagElement(key, getNeighborhoodItemText(val), "Neighborhoods", id, disabled);
                tag = this.getTagElement(key, getNeighborhoodItemText(val), "", id, disabled);
                break;
            }
            case "regionalboardcode": {
                tag = this.getTagElement(key, "Include ", val.split(',').join(', '), id, disabled);
                break;
            }
            case "isnewconstruction": {
                tag = this.getTagElement(key, "New Construction", "", id, disabled);
                break;
            }
            case "isforeclosure": {
                tag = this.getTagElement(key, "Foreclosure", "", id, disabled);
                break;
            }
            case "isfarmland": {
                tag = this.getTagElement(key, "Farm Land", "", id, disabled);
                break;
            }
            case "stories": {
                tag = this.getTagElement(key, val, "", id, disabled);
                break;
            }
            case "condotype": {
                tag = this.getTagElement(key, val.replace("Condominium","Condo Only").replace("Townhouse","Townhomes Only").replace("Patio Home Detached","Patio Homes Only"), "", id, disabled);
                break;
            }
            case "lotfeature": {
                tag = this.getTagElement(key, Array.isArray(val) ? val.join(', ') : val.split(',').join(', '), "Lot Feature", id, disabled);
                break;
            }
            case "propertystyle": {
                tag = this.getTagElement(key, Array.isArray(val) ? val.join(', ') : val.split(',').join(', '), "Style", id, disabled);
                break;
            }
            case "roompref": {
                tag = this.getTagElement(key, Array.isArray(val) ? val.join(', ') : val.split(',').join(', '), "Rooms", id, disabled);
                break;
            }
            case "accessibility": {
                tag = this.getTagElement(key, Array.isArray(val) ? val.join(', ') : val.split(',').join(', '), "Accessibility", id, disabled);
                break;
            }
            case "postalcode": {
                //tag = this.getTagElement(key, val.split(',').join(', '), "Zip Code", id, disabled);
                tag = this.getTagElement(key, val.split(',').join(', '), "", id, disabled);
                break;
            }
            case "entrydayold": {
                tag = this.getTagElement(key, getNumberOfDaysWeeks(val) + " old", "", id, disabled);
                break;
            }
            case "homefeatures": {
                tag = this.getTagElement(key, Array.isArray(val) ? toProperCase(val.join(', ')) : toProperCase(val.split(',').join(', ')), "Home Features", id, disabled);
                break;
            }
            case "searchmap": {
                tag = this.getTagElement(key, "Map Filtered", "", id, disabled);
                break;
            }
            case "streetaddress": {
                tag = this.getTagElement(key, val, "Street Address", id, disabled);
                break;
            }
            case "city": {
                tag = this.getTagElement(key, val, "", id, disabled);
                break;
            }
            default :{
                break;
            }
        }
        return tag;
    }

    getTagElement(key, val, text, id, disabled) {
        if(disabled){
            return (<div id={"search-tag-" + key + "-" + id} key={id} className="tagdisabled" style={{cursor: "inherit"}}>
                        {val} <span className="tag-label">{text}</span>
                    </div>);
        }
        else{
            return (<div id={"search-tag-" + key + "-" + id} key={id} onClick={() => this.props.onRemoveSearchTag(key, val)} className="tag">
                        {val} <span className="tag-label">{text}</span>
                        <i className="fa fa-times mg-lt-5"></i>
                    </div>);
        }
    }

    getArrayTag = (key, val, id, disabled) => {
        var self = this;
        var aTag = [];
        var fdis = disabled;
        if(key.toLowerCase() === "propertytype" && val.length === 1){
            fdis = true;
        }
        val.map((v,j) => {
            aTag.push(self.getTag(key, v, (id + j), (v.toLowerCase() === "sf") ? fdis : disabled));
            return null;
        });
        return aTag;
    }

    render() {

        var self = this;
        var tags = null;
        
        if(self.props.searchParameters){

            var parameters = Object.assign({}, self.props.searchParameters);
            /* if(parameters.locationtext && parameters.locationtext !== ""){
                if(!parameters.MLSNumber){
                    parameters.location = parameters.locationtext;                
                    delete parameters["locationtext"];
                }
            } */

            /*if(parameters.tlcmin && parameters.tlcmax){
                parameters.tlcminmax = "$" + parameters.tlcmin + " - $" + parameters.tlcmax;
                delete parameters["tlcmin"];
                delete parameters["tlcmax"];
            }*/

            var tagClassName = "tags";
            if(self.props.darkTheme){
                tagClassName = "tags tagsdark";
            }

            tags = (<section className="breadcrumbheader tag-item-location">
                <div className="fluid row">
                    <div className={tagClassName}>
                        {Object.keys(parameters).map(function(key, i) {
                            if(Array.isArray(parameters[key]) && parameters[key].length > 0){
                                return self.getArrayTag(key, parameters[key], (Object.keys(parameters).length), self.props.disabled);
                            }
                            else if(key.toLowerCase() === "postalcode" && parameters[key].indexOf(",") > -1 && (parameters[key].split(",")).length > 0){
                                return self.getArrayTag(key, parameters[key].split(","), (Object.keys(parameters).length), self.props.disabled);
                            }
                            else if(key.toLowerCase() === "searchmap"){
                                if(SearchPageCustomizationOptions && SearchPageCustomizationOptions.ShowFilterWithInMap){
                                    return self.getTag(key, parameters[key], i, (key.toLowerCase() === "propertytype" && parameters[key].toLowerCase() === "sf") ? true : self.props.disabled);
                                }
                                else {
                                    return null;
                                }
                            }
                            else{
                                return self.getTag(key, parameters[key], i, (key.toLowerCase() === "propertytype" && parameters[key].toLowerCase() === "sf") ? true : self.props.disabled);
                            }                            
                        })}
                    </div>
                </div>
            </section>);
        }

        return (<div>{tags}</div>);
    }
}

export default SearchTags;